import React from "react";
import { Link } from "react-router-dom";
import "./notFound.scss";

export default function NotFound() {
  return (
    <div className="notfound-container">
      <div className="notfound-card">
        <h1 className="notfound-code">404</h1>

        <h2 className="notfound-title">Page Not Found</h2>

        <p className="notfound-text">
          The page you’re looking for doesn’t exist, was removed, or the URL might be incorrect.
        </p>

        <div className="notfound-divider"></div>

        <Link to="/" className="notfound-btn">
          Go Back to Home
        </Link>

        <p className="notfound-footer">
          © {new Date().getFullYear()} Brands on Move
        </p>
      </div>
    </div>
  );
}
